import { render, staticRenderFns } from "./TeminatTuruPicker.vue?vue&type=template&id=c21ff588"
import script from "./TeminatTuruPicker.vue?vue&type=script&lang=ts"
export * from "./TeminatTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports